import StoreTags from '@enums/StoreTags'
import { CommonQueryParams, ItemsFromResponse } from '@models/common'
import { RiskMapHistory, RiskMapHistoryOption } from '@models/riskMapHistory'
import emptySplitApi from '../api'
import { HYDRA_MEMBER, HYDRA_TOTAL_ITEMS } from '../../config/consts'

const BASE_URL = '/api/risk_map_histories'
const JOB_TAGS = [StoreTags.RISK_MAP_HISTORIES]

export const RiskMapHistorysApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRiskMapHistories: builder.query<
      { items: RiskMapHistoryOption[]; length: number },
      CommonQueryParams
    >({
      query: (params) => ({
        url: BASE_URL,
        params,
      }),
      transformResponse: (response: ItemsFromResponse<RiskMapHistory>) => ({
        items: response[HYDRA_MEMBER].map((item) => ({
          ...item,
          label: item.description,
          value: item['@id'],
        })),
        length: response[HYDRA_TOTAL_ITEMS],
      }),
      providesTags: JOB_TAGS,
    }),
  }),
})

export const { useGetRiskMapHistoriesQuery } = RiskMapHistorysApi
